
import { FormPage } from "../../types/form";

export const page2Config: FormPage = {
  page: 2,
  elements: [
    {
      id: "section_teaching_info",
      type: "section_header",
      label: "ข้อมูลการเรียนการสอน"
    },
    {
      id: "previous_report_button",
      type: "previous_report_button",
      label: "นำข้อมูลจากรายงานล่าสุดที่เคยส่ง",
      name: "previous_report_button",
    },
    {
      id: "location",
      type: "radio",
      label: "สถานที่สอน",
      name: "teaching_location",
      required: true,
      options: [
        { value: "online", label: "online" },
        { value: "siam", label: "สยาม" },
        { value: "ngamwongwan", label: "งามวงศ์วาน" }
      ]
    },
    {
      id: "teaching_type",
      type: "select",
      label: "ประเภทการสอน",
      name: "teaching_type",
      required: false,
      options: [
        { value: "Private มีชีท = คุณครูใช้ชีทตัวเอง", label: "Private มีชีท = คุณครูใช้ชีทตัวเอง" },
        { value: "Private ไม่มีชีท = คุณครูใช้ชีทของสถาบัน (ชีทภาษาไทย)", label: "Private ไม่มีชีท = คุณครูใช้ชีทของสถาบัน (ชีทภาษาไทย)" },
        { value: "Premier_TH ไม่มีชีท = คุณครูใช้ชีทของสถาบัน", label: "Premier_TH ไม่มีชีท = คุณครูใช้ชีทของสถาบัน" },
        { value: "Premier_TH มีชีท = คุณครูใช้ชีทตัวเอง/ชีทน้อง (ชีทภาษาไทย)", label: "Premier_TH มีชีท = คุณครูใช้ชีทตัวเอง/ชีทน้อง (ชีทภาษาไทย)" },
        { value: "Premier_Inter ไม่มีชีท = คุณครูใช้ชีทของสถาบัน (ชีทภาษาอังกฤษ)", label: "Premier_Inter ไม่มีชีท = คุณครูใช้ชีทของสถาบัน (ชีทภาษาอังกฤษ)" },
        { value: "Premier_Inter มีชีท = คุณครูใช้ชีทตัวเอง/ชีทน้อง (ชีทภาษาอังกฤษ)", label: "Premier_Inter มีชีท = คุณครูใช้ชีทตัวเอง/ชีทน้อง (ชีทภาษาอังกฤษ)" }
      ],
      placeholder: "เลือกประเภทการสอน"
    },
    {
      id: "teaching_date",
      type: "date",
      label: "วันที่สอนน้อง",
      name: "teaching_date",
      required: true,
      description: "หากครูกรอกวันที่ผิด จะทำให้การตรวจพัฒนการตกหล่น และส่งผลต่อการทำเงินเดือนค่ะ"
    },
    {
      id: "time_slot",
      type: "time_picker",
      label: "เวลาที่เริ่มสอน",
      name: "teaching_time_slot",
      required: true,
      description: "เลือกเวลาที่เริ่มสอน"
    },
    {
      id: "duration",
      type: "radio",
      label: "ระยะเวลาที่สอน",
      name: "teaching_duration",
      required: true,
      options: [
        { value: "30 นาที", label: "30 นาที" },
        { value: "1 ชม.", label: "1 ชม." },
        { value: "1.30 ชม.", label: "1.30 ชม." },
        { value: "2 ชม.", label: "2 ชม." },
        { value: "2.30 ชม.", label: "2.30 ชม." },
        { value: "3 ชม.", label: "3 ชม." },
        { value: "4 ชม.", label: "4 ชม." }
      ]
    },
    {
      id: "student_search",
      type: "student_search",
      label: "ค้นหาข้อมูลนักเรียน",
      name: "student_search",
      required: false,
      description: "ค้นหาโดยชื่อหรือชื่อเล่นนักเรียน"
    },
    {
      id: "student_fullname",
      type: "text",
      label: "ชื่อ - นามสกุล น้อง",
      name: "student_full_name",
      required: false,
      readOnly: true
    },
    {
      id: "student_nickname",
      type: "text",
      label: "ชื่อเล่นน้อง",
      name: "student_nickname",
      required: false,
      readOnly: true
    },
    {
      id: "student_id",
      type: "text",
      label: "รหัสนักเรียน",
      name: "student_id",
      required: false,
      readOnly: true
    },
    {
      id: "student_grade",
      type: "select",
      label: "ชั้นเรียนของน้อง",
      name: "student_grade_level",
      required: true,
      options: [
        { value: "ป.1", label: "ป.1" },
        { value: "ป.2", label: "ป.2" },
        { value: "ป.3", label: "ป.3" },
        { value: "ป.4", label: "ป.4" },
        { value: "ป.5", label: "ป.5" },
        { value: "ป.6", label: "ป.6" },
        { value: "ม.1", label: "ม.1" },
        { value: "ม.2", label: "ม.2" },
        { value: "ม.3", label: "ม.3" },
        { value: "ม.4", label: "ม.4" },
        { value: "ม.5", label: "ม.5" },
        { value: "ม.6", label: "ม.6" }
      ],
      placeholder: "เลือกระดับชั้น"
    },
    {
      id: "subject",
      type: "radio",
      label: "วิชา",
      name: "subject",
      required: true,
      options: [
        { value: "วิทยาศาสตร์", label: "วิทยาศาสตร์" },
        { value: "คณิตศาสตร์", label: "คณิตศาสตร์" },
        { value: "ฟิสิกส์", label: "ฟิสิกส์" },
        { value: "เคมี", label: "เคมี" },
        { value: "ชีวะ", label: "ชีวะ" },
        { value: "สังคม", label: "สังคม" },
        { value: "ภาษาไทย", label: "ภาษาไทย" },
        { value: "ภาษาอังกฤษ", label: "ภาษาอังกฤษ" },
        { value: "ภาษาจีน", label: "ภาษาจีน" }
      ]
    },
    {
      id: "learning_status",
      type: "radio",
      label: "สถานะการเรียน",
      name: "learning_status",
      required: true,
      options: [
        { value: "เข้าเรียน/เข้าสอนปกติ", label: "เข้าเรียน/เข้าสอนปกติ" },
        { value: "น้องไม่เข้าเรียน (ลากะทันหัน)", label: "น้องไม่เข้าเรียน (ลากะทันหัน)" }
      ]
    },
    {
      id: "checkin_photo",
      type: "file",
      label: "รูปภาพ Check-In เข้าสอน",
      name: "check_in_photo_urls",
      required: true,
      description: "ให้แคปภาพหน้าจอก่อนเริ่มสอนส่งแทนนะคะ โดยรูปจะต้องเห็นเวลาชัดเจน...\nกรณีครูสาขา ให้ครูถ่ายรูปคู่เด็กที่สอน...",
      validation: {
        maxFiles: 1,
        maxSizeMB: 5
      }
    }
  ]
};
